import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";
import { total_medio_ciclo } from "../../services/api";
import { ConverteSerie, ConverteSegmentoSig } from "./modulo";

const Total_ciclo_segmento = (props) => {
    const [data2, setData2] = useState([]);
    const [avaliacao, setAvaliacao] = useState('AS1');
    const [serie, setSerie] = useState('1-1');

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];

    let cod_unidade = props.un;

    // Lista de opções para os ComboBoxes

    const fetchData = async () => {
        try {
            const response = await total_medio_ciclo();
            console.log("RES22=", response);
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [avaliacao, serie]);

    let chartDatSerie = [];

    let data2Filter = data2.filter(item => item.unidade === cod_unidade);

    console.log('data2Filter', data2Filter)

    if (typeof data2Filter !== 'undefined') {
        chartDatSerie = data2Filter.map((item, index) => {
            const row = [ConverteSerie(item.segmento)];
            //row.push(ConverteSerie(item.segmento))
            row.push(item.mc1);
            row.push(item.mc2);
            row.push(item.mc3);
            row.push(item.mc4);
            return row;

        });
    };

    // chartDatSerie.sort();
    chartDatSerie.unshift(["Segmento", "M. Ciclo 1", "M. Ciclo 2", "M. Ciclo 3", "M. Ciclo 4"]);

    const options = {
        allowHtml: true,
    };

    const formatters = [
        {
            type: "ColorFormat",
            column: 1,
            ranges: [
                [0, 17.5, "red", "white"],
                [17.5, 25, "blue", "white"],
            ],
        },
        {
            type: "ColorFormat",
            column: 2,
            ranges: [
                [0, 17.5, "red", "white"],
                [17.5, 25, "blue", "white"],
            ],
        },
        {
            type: "ColorFormat",
            column: 3,
            ranges: [
                [0, 17.5, "red", "white"],
                [17.5, 25, "blue", "white"],
            ],
        },
        {
            type: "ColorFormat",
            column: 4,
            ranges: [
                [0, 17.5, "red", "white"],
                [17.5, 25, "blue", "white"],
            ],
        },
    ];

    return (
        <div className="Média_ciclo" style={{ border: "1px solid #ccc", boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", padding: "20px", borderRadius: "8px" }}>
            <center>
                <h5><b>
                    Média do Somatório de notas por Ciclo.
                </b>
                </h5>
            </center>

            <br />

            <center>
                <Chart
                    chartType="Table"
                    width="100%"
                    data={chartDatSerie}
                    options={options}
                    formatters={formatters}
                />
            </center>
        </div>
    );
};

export default Total_ciclo_segmento;
